module.exports = __webpack_public_path__ + "img/premier-travel-logo.c3edfb88.jpg";